export default __webpack_public_path__ + "static/media/flayer6.85cee2c8.jpg";